<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section id="about">
            <br>
            <header><h3>Association of Pali and Buddhist Studies</h3></header>
            <img src="assets/img/association_of_pali_and_buddhist_studies.jpg">
            <hr>
            <p>
              The Association of Pali and Buddhist Studies consists of Pali, Buddhist Culture and Buddhist Philosophy Special degree students. This association organizes events such as field trips and researches to enhance students’ capacities and academic capabilities.
            </p>
            <hr>
            <h4>Objectives</h4>
            <ul class="element-framed">
              <li>To organize events to develop theoretical and practical knowledge of the students</li>
              <li>To encourage students’ extra-curricular activities</li>
              <li>To publish the ‘Gnangawesi’ annual magazine</li>
            </ul>
            <hr>
          </section>
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <br>
          <aside id="our-professors">
            <header>
              <h5>Office Bearers</h5>
            </header>
            <div class="section-content">
              <div class="professors">
                <aside>
                  <header>
                    <b>Advising Committee</b>
                    <figure class="professor-description">
                      Head of the Department and members of the academic staff
                    </figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>President</b>
                    <figure class="professor-description">Ven. Siyambalagoda Sudhamma</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Secretary</b>
                    <figure class="professor-description">Sureka Lakmasli, A.G.</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Vice President</b>
                    <figure class="professor-description">Ven. Lunugalakolaniye Pannasara</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Vice Secretary</b>
                    <figure class="professor-description">Madhushan, M.A.I.L.</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Senior Treasurer</b>
                    <figure class="professor-description">Ven. Taldena Ariyawimala</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Junior Treasurer</b>
                    <figure class="professor-description">Ishanka, K.P.G.S.</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Senior Editor</b>
                    <figure class="professor-description">Ven. Seenipelle Vimalagnanadeepa</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Junior Editor</b>
                    <figure class="professor-description">Ven. Mahakumbukkadawala Siriwimala</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Committee Members</b>
                    <figure class="professor-description">
                      Ven. Himbiliyakada Paduma<br>
                      Ven. Nawela Chandananda<br>
                      Ven. Konkotanmulle Sankichcha<br>
                      Shalika, D.A.I.S.<br>
                      Nilupul, H.I.H<br>
                      Niroshani, K.A<br>
                    </figure>
                  </header>
                </aside>
              </div><!-- /.professors -->
            </div><!-- /.section-content -->
          </aside><!-- /.our-professors -->
        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
